const Toggle = (label) => {

    // Fetch the trigger link for this toggle system
    let toggle = document.querySelector(`[data-${label}-toggle]`);
    // Set up aria label status on the trigger button
    toggle.ariaExpanded = false;

    // Fetch the class name from the data attribute
    let className = toggle.getAttribute(`data-${label}-toggle`);
    // Find the corresponding element with this class name
    let targetElement = document.querySelector(`.${className}`);

    // Fetch the close button for this toggle system
    let closeButton = document.querySelector(`[data-${label}-close]`);

    // If the element is defined/exists, proceed
    if (typeof targetElement != "undefined" && targetElement != null) {


        // When the toggle button is clicked
        toggle.addEventListener('click', () => {  
            
            // If the aria label suggests this is closed, set the label to active
            if (toggle?.ariaExpanded === 'false') {
                toggle.ariaExpanded = true;
                // Focus on the target div
                setTimeout(function(){
                    targetElement.focus();
                },30);
            } else {
                toggle.ariaExpanded = false;
            }

            // If the close button is set to be inaccessible via keyboard, activate this
            if (closeButton?.getAttribute('tabindex') === '-1') {
                closeButton.setAttribute('tabindex', 0);
            } else {
                closeButton.setAttribute('tabindex', -1);
            }

            if (targetElement?.getAttribute('tabindex') === '-1') {
                targetElement.setAttribute('tabindex', 0);
            } else {
                targetElement.setAttribute('tabindex', -1);
            }

            // Toggle the --active BEM modifier on the referred element
            targetElement.classList.toggle(`${className}--active`);
                
        });
    }

    // If the close button is defined/exists, proceed
    if (typeof closeButton != "undefined" && closeButton != null) {

        // When the button is clicked
        closeButton.addEventListener('click', () => {
            // Set the expanded state on the trigger button to false
            toggle.ariaExpanded = false;
            // Hide the close button from being accessible via keyboard to prevent tab issues
            closeButton.setAttribute('tabindex', -1);
            // Toggle the --active BEM modifier on the referred element
            targetElement.classList.remove(`${className}--active`);
            // Focus back on the trigger we used to open the button to user assistance
            toggle.focus();
        });
    }
}

export default Toggle;